import axios from 'axios';

const getApiUrl = () => {
    switch (process.env.NODE_ENV) {
      case 'development':
        return 'http://localhost:3001'; // Your local dev server
      case 'production':
        return 'https://agent-assistant-be.onrender.com'; // Your production API
      default:
        return 'http://localhost:8080';
    }
  };

  class TokenService {
    constructor() {
        this.accessToken = localStorage.getItem('accessToken');
        this.refreshToken = localStorage.getItem('refreshToken');
        this.userId = localStorage.getItem('userId');
        this.profileImage = localStorage.getItem('profileImage');
        this.isRefreshing = false;
        this.refreshSubscribers = [];
    }

    // Store tokens
    setTokens(accessToken, refreshToken, userId, profileImage) {
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
        this.userId = userId;
        this.profileImage = profileImage;
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('userId', userId);
        localStorage.setItem('profileImage', profileImage);
    }

    // Clear tokens on logout
    clearTokens() {
        this.accessToken = null;
        this.refreshToken = null;
        this.userId = null;
        this.profileImage = null;
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('profileImage');
    }

    // Subscribe to token refresh
    subscribeToRefresh(callback) {
        this.refreshSubscribers.push(callback);
    }

    // Notify subscribers with new token
    onRefreshSuccess(newToken) {
        this.refreshSubscribers.forEach(callback => callback(newToken));
        this.refreshSubscribers = [];
    }

    // Refresh the access token
    async refreshAccessToken() {
        try {
            if (this.isRefreshing) {
                // Wait for the ongoing refresh to complete
                return new Promise(resolve => {
                    this.subscribeToRefresh(token => {
                        resolve(token);
                    });
                });
            }

            this.isRefreshing = true;

            const response = await fetch('/api/auth/refresh', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    refreshToken: this.refreshToken
                })
            });

            if (!response.ok) {
                throw new Error('Token refresh failed');
            }

            const data = await response.json();
            this.setTokens(data.accessToken, data.refreshToken, this.userId);
            this.onRefreshSuccess(data.accessToken);
            this.isRefreshing = false;

            return data.accessToken;
        } catch (error) {
            this.isRefreshing = false;
            this.clearTokens();
            throw error;
        }
    }
}

const tokenService = new TokenService();

const api = axios.create({
    baseURL: getApiUrl()
});

// Request interceptor
api.interceptors.request.use(
    config => {
        if (tokenService.accessToken) {
            config.headers.Authorization = `Bearer ${tokenService.accessToken}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        // If error is not 401 or request has already been retried
        //498 is the code for token refresh
        if (error.response?.status !== 498 || originalRequest._retry) {
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        try {
            const newAccessToken = await tokenService.refreshAccessToken();
            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
            return api(originalRequest);
        } catch (refreshError) {
            // Handle refresh failure (e.g., redirect to login)
            window.location.href = '/login';
            return Promise.reject(refreshError);
        }
    }
);

export { tokenService, api };
  
//export const API_BASE_URL = getApiUrl();



